import { styled } from '@mui/material';

import { DRAWER_WIDTH } from '@src/constants';

const MainScreenContainer = styled('div')(({ isDrawerOpen }: { isDrawerOpen: boolean }) => {
  return {
    transition: `margin 0.5s cubic-bezier(0.4, 0, 0.2, 1)`,
    marginRight: isDrawerOpen ? DRAWER_WIDTH : 0,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: 'calc(100% - 90px)',
  };
});

export default MainScreenContainer;
